module.exports = __webpack_public_path__ + "img/hailan.d532b2b5.png";